





































import iwOrderSummary from "@/encoding/pages/questions/payment/OrderSummary.vue";
import iwPaymentMethod from "@/encoding/pages/questions/payment/PaymentMethod.vue";
import iwTermsAgreement from "@/encoding/pages/questions/payment/TermsAgreement.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import iwDeliveryNoticeCallout from "@/optimizedEncoding/components/DeliveryNoticeCallout.vue";
import missingCustomerNameMixin from "@/shared/mixins/missingCustomerName";
import { mapClassifiedTypeToGA4, pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { mapActions, mapGetters, mapState } from "vuex";
import thor from "@sl/thor";

export default missingCustomerNameMixin.extend({
    components: {
        iwOrderSummary: iwOrderSummary,
        iwPaymentMethod: iwPaymentMethod,
        iwTermsAgreement: iwTermsAgreement,
        iwNextPreviousButton: iwNextPreviousButton,
        iwDeliveryNoticeCallout: iwDeliveryNoticeCallout
    },

    props: {
        action: {
            type:String,
            required: false,
            default: "PUBLICATION"
        }
    },

    data: function() {
        return {
            isButtonDisabledInternal: false as boolean
        };
    },

    computed: {
        ...mapState("OrdersModule", ["currentOrder", "transactions"]),
        ...mapState("AgreementModule", ["termsAndConditions"]),
        ...mapGetters({
            getStep: "StepsWizard/getStep",
        }),
        paymentDeclined: function(): boolean {
            return !!this.$route.query.error;
        },
        isButtonDisabled: function(): boolean {
            return this.isButtonDisabledInternal || !this.termsAndConditions || !this.transactions.initial?.paymentMethod;
        },
    },

    created: function() {
        const pictures = this.$store.getters["PicturesModule/getPictures"];
        if (!pictures || pictures.length === 0) {
            this.routeToPage("step-pictures");
            return;
        }

        this.setCurrent(this.getStep(this.$router.currentRoute.name));
        const orderId = this.$route.query.orderId as string;
        localStorage.removeItem("optimized");

        if (orderId) {
            this.getOrderById({
                orderId: orderId,
                errorRoute: this.$route.name,
                pricingType: this.action
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
            });
        }
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step13_payment");
    },

    methods: {
        ...mapActions("OrdersModule", ["getOrderById", "createTransaction"]),
        ...mapActions({
            validateAndGoToNextStep: "FormModule/validateAndGoToNextStep",
            goToPreviousStep: "StepsWizard/previous",
            setCurrent : "StepsWizard/current"
        }),
        clickNext: function() {
            // Backstop: the order (and therefore the Salesforce B2C log) is already created on
            // the way into this step, so this guard only catches a name that went bad afterwards.
            // Checked before the in-flight flag is raised below, so there is nothing to reset here.
            if (this.blockOnMissingCustomerName(this.clickNext)) {
                return false;
            }

            // Disable + spin the button before the request so a double-click can't fire
            // multiple Worldline transactions; reset on the failure / no-redirect paths below.
            this.isButtonDisabledInternal = true;
            this.createTransaction()
                .then(transaction => {
            
                    if (transaction.hostedCheckoutId) {
                        localStorage.setItem("hostedCheckoutId", transaction.hostedCheckoutId);
                    }
                    this.classifiedDepositSubmit();

                    const redirectUrl = transaction.redirectUrl;

                    if (!redirectUrl) {
                        this.isButtonDisabledInternal = false;
                        return;
                    }
                    window.location.href = redirectUrl;
                })
                .catch(error => {
                    this.isButtonDisabledInternal = false;
                    console.error(error);
                });

            return false;
        },
        clickPrevious: function(){

            this.goToPreviousStep();
        },
        classifiedDepositSubmit: function() {
            thor.pushEvent(
                "classified_deposit_submit",
                {
                    "av_feature": "classified_deposit",
                    "av_user": {
                        "project": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "WantsToSell" : "WantsToRent",
                    },
                    "av_distribution_type_global": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
                    "av_estate_type_global": mapClassifiedTypeToGA4(this.$store.getters["FormModule/getValue"]("property.type")),
                    "av_distribution_subtype": this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
                }
            );
        }
    },
});

